module.exports = __webpack_public_path__ + "static/media/fabien-bazanegue.5c4418a6.jpg";